import Service from "./Service";
const baseurl = '/api/convenciones-procedimientos-odontograma';
export default {
    index() {
        return Service.get(`${baseurl}`);
    }
}